import { render, staticRenderFns } from "./CompanionAnimalFacts.vue?vue&type=template&id=5c70ff78"
import script from "./CompanionAnimalFacts.vue?vue&type=script&lang=ts"
export * from "./CompanionAnimalFacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports